import { Table, useApiQuery, type Column, type Invoice } from 'grabbitbot-legacy-ui'
import { paymentClient } from '../../api'
import { formatMinorUnits } from '../../payment/money'

/** Equivalent of legacy `PaymentInvoiceListComponent` — no shared-library
 * component exists for this list (README's module map doesn't include an
 * `InvoiceList`), so it's built directly on the shared `Table`, same
 * pattern as `TransactionHistoryTable` inside the library itself. */
export function PaymentInvoicesPage() {
  const { data, loading, error } = useApiQuery(() => paymentClient.searchInvoices(), [])

  const columns: Column<Invoice>[] = [
    { key: 'number', label: 'Number', align: 'left' },
    { key: 'effective_at', label: 'Date', align: 'left' },
    {
      key: 'total',
      label: 'Total',
      // Stripe's `total` is an integer minor-unit amount (cents for a
      // 2-decimal currency) — never render it raw (BubbleTicket
      // invoice-minor-units ticket: a $19.99 invoice showed "1999"). See
      // `../../payment/money.ts` for why a flat `/ 100` is also wrong
      // (zero-/three-decimal currencies).
      format: (v, row) => formatMinorUnits(typeof v === 'number' ? v : null, row.currency),
    },
    { key: 'currency', label: 'Currency' },
    {
      key: 'hosted_invoice_url',
      label: '',
      sortable: false,
      format: (v) =>
        typeof v === 'string' && v ? (
          <a href={v} target="_blank" rel="noreferrer">
            View
          </a>
        ) : null,
    },
  ]

  // GET /payment/invoices returns the Stripe search-result envelope
  // (`{data: Invoice[], count, has_more, ...}`), never a bare array — the
  // rows live under `.data` (BubbleTicket c893af23; api.feesubscription.com
  // `search_invoices` / `InvoiceSearchResult`).
  const rows = data?.data ?? []

  return (
    <div>
      <h1>Invoices</h1>
      {loading && <p>Loading invoices…</p>}
      {error && <p role="alert">Could not load invoices.</p>}
      {data && (
        <Table columns={columns} rows={rows} rowKey={(row, i) => row.id ?? i} initialSort={{ key: 'effective_at', dir: 'desc' }} />
      )}
    </div>
  )
}
